// Simulated data for the auction
export const SIMULATED_DATA = {
    1: { users: 147, sol: 38.00, jinu: 1012500 }, // +35.0%
    2: { users: 147, sol: 129.00, jinu: 487500 }, // -35.0%
    3: { users: 130, sol: 36.00, jinu: 990000 },  // +32.0%
    4: { users: 96, sol: 48.00, jinu: 510000 },   // -32.0%
    5: { users: 123, sol: 133.00, jinu: 967500 }, // +29.0%
    6: { users: 55, sol: 27.00, jinu: 532500 },   // -29.0%
    7: { users: 29, sol: 88.00, jinu: 945000 },   // +26.0%
    8: { users: 146, sol: 40.00, jinu: 555000 },  // -26.0%
    9: { users: 36, sol: 117.00, jinu: 922500 },  // +23.0%
    10: { users: 79, sol: 106.00, jinu: 577500 }, // -23.0%
    11: { users: 83, sol: 26.00, jinu: 900000 },  // +20.0%
    12: { users: 48, sol: 39.00, jinu: 600000 },  // -20.0%
    13: { users: 96, sol: 144.00, jinu: 877500 }, // +17.0%
    14: { users: 27, sol: 120.00, jinu: 622500 }, // -17.0%
    15: { users: 109, sol: 14.00, jinu: 855000 }, // +14.0%
    16: { users: 54, sol: 73.00, jinu: 645000 },  // -14.0%
    17: { users: 128, sol: 51.00, jinu: 832500 }, // +11.0%
    18: { users: 47, sol: 25.00, jinu: 667500 },  // -11.0%
    19: { users: 109, sol: 101.00, jinu: 810000 },// +8.0%
    20: { users: 37, sol: 136.00, jinu: 690000 }, // -8.0%
    21: { users: 122, sol: 88.00, jinu: 787500 }, // +5.0%
    22: { users: 22, sol: 78.00, jinu: 712500 },  // -5.0%
    23: { users: 135, sol: 31.00, jinu: 765000 }, // +2.0%
    24: { users: 79, sol: 42.00, jinu: 735000 },  // -2.0%
    25: { users: 52, sol: 35.00, jinu: 750000 },  // 0.0% (base)
    26: { users: 56, sol: 120.00, jinu: 1005000 },// +34.0%
    27: { users: 34, sol: 26.00, jinu: 495000 },  // -34.0%
    28: { users: 84, sol: 137.00, jinu: 982500 }, // +31.0%
    29: { users: 115, sol: 125.00, jinu: 517500 },// -31.0%
    30: { users: 137, sol: 146.00, jinu: 960000 },// +28.0%
    31: { users: 45, sol: 35.00, jinu: 540000 },  // -28.0%
    32: { users: 54, sol: 133.00, jinu: 937500 }, // +25.0%
    33: { users: 83, sol: 141.00, jinu: 562500 }, // -25.0%
    34: { users: 114, sol: 47.00, jinu: 915000 }, // +22.0%
    35: { users: 138, sol: 101.00, jinu: 585000 },// -22.0%
    36: { users: 50, sol: 36.00, jinu: 892500 },  // +19.0%
    37: { users: 90, sol: 78.00, jinu: 607500 },  // -19.0%
    38: { users: 30, sol: 123.00, jinu: 870000 }, // +16.0%
    39: { users: 122, sol: 12.00, jinu: 630000 }, // -16.0%
    40: { users: 34, sol: 25.00, jinu: 847500 },  // +13.0%
    41: { users: 57, sol: 146.00, jinu: 652500 }, // -13.0%
    42: { users: 138, sol: 138.00, jinu: 825000 },// +10.0%
    43: { users: 74, sol: 47.00, jinu: 675000 },  // -10.0%
    44: { users: 148, sol: 127.00, jinu: 802500 },// +7.0%
    45: { users: 146, sol: 106.00, jinu: 697500 },// -7.0%
    46: { users: 64, sol: 77.00, jinu: 1005000 },  // +34.0%
    47: { users: 82, sol: 110.00, jinu: 990000 },  // +32.0%
    48: { users: 134, sol: 120.00, jinu: 1012500 },// +35.0%
    49: { users: 43, sol: 72.00, jinu: 997500 },   // +33.0%
    50: { users: 65, sol: 43.00, jinu: 975000 }    // +30.0%
};

// Total simulated values
export const TOTAL_SIMULATED_USERS = 4273;
export const TOTAL_SIMULATED_SOL = 4036;
export const TOTAL_SIMULATED_JINU = 37500000; // 37.5M JINU

// Flag to enable/disable simulated data
export const useSimulatedData = true;

// Get simulated data for a specific day
export const getSimulatedData = (day) => {
    if (!useSimulatedData || !SIMULATED_DATA[day]) {
        return { users: 0, sol: 0, jinu: 0 };
    }
    return SIMULATED_DATA[day];
};
